(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 260;
  var EASING = 'ease-in-out';

  function AwAccordion(details) {
    this.details = details;
    this.summary = details.querySelector(':scope > summary');
    this.body = details.querySelector(':scope > summary + *');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (!this.summary || !this.body) return;

    this.onClick = this.onClick.bind(this);
    this.summary.addEventListener('click', this.onClick);
  }

  AwAccordion.prototype.onClick = function (event) {
    event.preventDefault();

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  AwAccordion.prototype.shrink = function () {
    this.isClosing = true;
    this.details.classList.remove('is-active');

    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.details.style.overflow = 'hidden';
    this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });

    var self = this;
    this.animation.onfinish = function () {
      self.onAnimationFinish(false);
    };
    this.animation.oncancel = function () {
      self.isClosing = false;
    };
  };

  AwAccordion.prototype.open = function () {
    this.details.style.overflow = 'hidden';
    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    this.details.classList.add('is-active');

    var self = this;
    window.requestAnimationFrame(function () {
      self.expand();
    });
  };

  AwAccordion.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.body.offsetHeight + 'px';

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });

    var self = this;
    this.animation.onfinish = function () {
      self.onAnimationFinish(true);
    };
    this.animation.oncancel = function () {
      self.isExpanding = false;
    };
  };

  AwAccordion.prototype.onAnimationFinish = function (isOpen) {
    this.details.open = isOpen;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  };

  function init(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll('details[data-aw-accordion]');

    elements.forEach(function (details) {
      if (details.dataset.awAccordionInitialized) return;
      details.dataset.awAccordionInitialized = 'true';

      if (details.open) details.classList.add('is-active');
      if (REDUCED_MOTION || typeof details.animate !== 'function') return;

      new AwAccordion(details);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
